import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase'; 
import { onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, onSnapshot, getDoc, updateDoc, increment } from 'firebase/firestore';

// Components Imports
import Auth from './Register';
import Watch from './Watch';
import Wallet from './Wallet';
import Tasks from './Tasks';
import Shop from './Shop'; 
import Promo from './Promo';
import Profile from './Profile';
import AdminPanel from './Admin'; 
import './App.css'; 

const ADMIN_EMAIL = "mret1424@gmail.com"; 

function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentScreen, setCurrentScreen] = useState('dashboard');
  const [isAdmin, setIsAdmin] = useState(false);

  // 🔴 VPN & Security States
  const [isVpnActive, setIsVpnActive] = useState(false);
  const [vpnSettings, setVpnSettings] = useState({ enabled: false, action: 'block' });

  // Timer & Cooldown States
  const [adCooldown, setAdCooldown] = useState(false); 
  const [adCounting, setAdCounting] = useState(false); 
  const [timeLeft, setTimeLeft] = useState(0);
  const [isAdLoading, setIsAdLoading] = useState(false);

  // ၁။ YouTube API Pre-load
  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  }, []);

  // 🔴 VPN CHECK FUNCTION (ယာယီပိတ်ထားသည် - Loading တန့်ခြင်းမှ ကာကွယ်ရန်)
  const checkVPNStatus = async () => {
    // မြန်မာပြည်မှ API ခေါ်ယူ၍မရသောကြောင့် အမြဲတမ်း false (VPN မရှိဟု) ပြန်ပေးရန် ပြင်ဆင်ထားသည်
    return false; 

    /* မူရင်း Code ကို သိမ်းထားလိုပါက အောက်တွင်ကြည့်နိုင်သည်
    try {
      const res = await fetch('https://ipapi.co/json/');
      const data = await res.json();
      const detected = data.country_code !== 'MM' || data.proxy === true;
      setIsVpnActive(detected);
      return detected;
    } catch (e) {
      console.error("VPN Check Error:", e);
      return false;
    }
    */
  };

  // ၂။ Auth & Real-time Data Management
  useEffect(() => {
    let unsubDoc = null; 

    // 🔴 Load Admin VPN Settings
    const fetchAdminSettings = async () => {
      try {
        const s = await getDoc(doc(db, "admin", "settings"));
        if(s.exists()){
            const d = s.data();
            setVpnSettings({ enabled: d.vpnCheckEnabled, action: d.vpnAction });
            
            // VPN Check ကို Enabled လုပ်ထားသော်လည်း API error ကြောင့် Loading မတန့်စေရန် ဤနေရာတွင် မခေါ်တော့ပါ
            // if(d.vpnCheckEnabled) checkVPNStatus(); 
        }
      } catch (err) {
        console.error("Admin Settings Error:", err);
      }
    };

    fetchAdminSettings();

    // အခြား Auth ပိုင်းဆိုင်ရာ logic များ ဤအောက်တွင် ဆက်လက်ရှိနိုင်ပါသည်...


    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      if (unsubDoc) {
        unsubDoc();
        unsubDoc = null;
      }

      if (currentUser) {
        setIsAdmin(currentUser.email === ADMIN_EMAIL);
        setUser(currentUser);
        
        const userRef = doc(db, "users", currentUser.uid);

        unsubDoc = onSnapshot(userRef, async (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();

          // --- ဒီအပိုင်းကို စတင်ထည့်သွင်းပါ ---
          // 🔥 user ရှိမှသာ အထဲက ကုဒ်တွေကို အလုပ်လုပ်ခိုင်းမယ်
if (user && user.uid && data.memberType === 'Premium' && data.expiryDate) {
    const now = new Date();
    let exp;

    if (data.expiryDate && typeof data.expiryDate.toDate === 'function') {
        exp = data.expiryDate.toDate();
    } else {
        exp = new Date(data.expiryDate);
    }

    if (now > exp) {
        // (၁) ရက်ကုန်သွားလျှင် Free ပြန်ပြောင်းမည်
        updateDoc(doc(db, "users", user.uid), {
            memberType: 'Free',
            premium: 0,
            expiryDate: null
        });
    } else {
        // (၂) ရက်မကုန်သေးလျှင် ကျန်ရက်ကို တွက်မည်
        const diffTime = exp - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays !== data.premium) {
            updateDoc(doc(db, "users", user.uid), {
                premium: diffDays
            });
        }
    }
}

          setUserData(data);
            
            const today = new Date().toDateString();
            if (data.lastAdDate !== today) {
              await updateDoc(userRef, {
                adsWatchedToday: 0,
                lastAdDate: today
              });
            }

            setUserData(data);
          } else {
            const newData = { 
              points: 0, 
              memberType: 'Free', 
              email: currentUser.email,
              name: currentUser.displayName || currentUser.email.split('@')[0],
              usedPromoCodes: [],
              createdAt: new Date(),
              watchPoints: 0,
              refPoints: 0,
              taskPoints: 0,
              adsWatchedToday: 0,
              lastAdDate: new Date().toDateString()
            };
            try {
              await setDoc(userRef, newData);
              setUserData(newData);
            } catch (err) {
              console.error("SetDoc Error:", err);
            }
          }
          setLoading(false); 
        }, (error) => {
          console.error("Firestore Snapshot Error:", error);
          setLoading(false);
        });

      } else {
        setUser(null);
        setUserData(null);
        setIsAdmin(false);
        setLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubDoc) unsubDoc();
    };
  }, []);

  // --- Watch Ads Function ---
  const handleWatchAds = async () => {
    if (adCooldown || adCounting || isAdLoading) return;

    // 🔴 VPN Check Logic
    if (vpnSettings.enabled) {
        const vpnDetected = await checkVPNStatus();
        if (vpnDetected) {
            if (vpnSettings.action === 'block') {
                return alert("⚠️ VPN သုံးထားသဖြင့် ကြော်ငြာကြည့်၍မရပါ။ ကျေးဇူးပြု၍ VPN ပိတ်ပြီးမှ ပြန်ကြိုးစားပါ။");
            } else {
                alert("⚠️ သတိပေးချက်- VPN သုံးထားသည်ကို တွေ့ရှိရပါသည်။ ဒါက သင့်အကောင့်ကို ထိခိုက်စေနိုင်ပါသည်။");
            }
        }
    }

    try {
        setIsAdLoading(true);
        const settingsRef = doc(db, "admin", "settings");
        const settingsSnap = await getDoc(settingsRef);

        if (!settingsSnap.exists()) {
            setIsAdLoading(false);
            return alert("Settings not found!");
        }

        const getPremiumDays = (expiry) => {
    if (!expiry) return 0;
    try {
      const now = new Date();
      const exp = expiry.toDate ? expiry.toDate() : new Date(expiry);
      const diff = exp - now;
      return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
    } catch (e) { return 0; }
  };
        const settings = settingsSnap.data();
        const adLink = settings.adsterraLink;
        
        const limit = settings.dailyAdLimit || 20; 
        const currentWatched = userData?.adsWatchedToday || 0;

        if (currentWatched >= limit) {
            setIsAdLoading(false);
            alert(`ဒီနေ့အတွက် Ads ကြည့်ရှုခွင့် ${limit} ကြိမ် ပြည့်သွားပါပြီ။ မနက်ဖြန်မှ ပြန်လာခဲ့ပါဗျာ။`);
            return;
        }

        const confirmWatch = window.confirm(
          `ယနေ့ကြည့်ပြီး - ${currentWatched}/${limit} ကြိမ်\n\n၁။ OK နှိပ်ပြီးနောက် ပွင့်လာမည့် ကြော်ငြာကို ၁၀ စက္ကန့် ကြည့်ပေးပါ။\n၂။ ထို့နောက် Points များ အလိုအလျောက် တိုးလာပါလိမ့်မည်။`
        );

        if (!confirmWatch) {
            setIsAdLoading(false);
            return;
        }

        const adWindow = window.open('', '_blank');

        if (adLink) {
            adWindow.location.href = adLink;
            setIsAdLoading(false);
            
            setAdCounting(true);
            let count = 10;
            setTimeLeft(count);

            const timer = setInterval(async () => {
                count--;
                setTimeLeft(count);

                if (count <= 0) {
                    clearInterval(timer);
                    setAdCounting(false);
                    
                    const rewardAmount = userData?.memberType === 'Premium' 
                        ? (settings.adsPremiumPoints || 10) 
                        : (settings.adsFreePoints || 5);

                    const userRef = doc(db, "users", auth.currentUser.uid);
                    
                    await updateDoc(userRef, {
                        points: increment(Number(rewardAmount)),
                        watchPoints: increment(Number(rewardAmount)),
                        adsWatchedToday: increment(1),
                        lastAdDate: new Date().toDateString()
                    });

                    alert(`ဂုဏ်ယူပါတယ်! ${rewardAmount} Pts ရရှိပါပြီ။ (ယနေ့ကြည့်ပြီး: ${currentWatched + 1}/${limit})`);

                    setAdCooldown(true);
                    let cooldown = 60;
                    setTimeLeft(cooldown);
                    
                    const cooldownTimer = setInterval(() => {
                        cooldown--;
                        setTimeLeft(cooldown);
                        if (cooldown <= 0) {
                            clearInterval(cooldownTimer);
                            setAdCooldown(false);
                        }
                    }, 1000);
                }
            }, 1000);
        } else {
            if(adWindow) adWindow.close();
            setIsAdLoading(false);
            alert("Ads link မရှိသေးပါ။");
        }
    } catch (error) {
        setIsAdLoading(false);
        console.error("Ads Error:", error);
    }
  };

  const getPremiumDays = (expiry) => {
    if (!expiry) return 0;
    const expiryDate = expiry.seconds ? new Date(expiry.seconds * 1000) : new Date(expiry);
    const diff = expiryDate - new Date();
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 0;
  };

  if (loading) return (
    <div className="preloader">
      <div className="loader-dots"><div className="dot"></div><div className="dot"></div><div className="dot"></div></div>
      <h2>BABYLON</h2>
    </div>
  );

  if (!user) return <Auth />;

  return (
    <div className="App">
      {currentScreen === 'dashboard' && (
        <div className="dashboard-container">
          
          {/* 🔴 VPN Warning Alert on UI */}
          {vpnSettings.enabled && isVpnActive && (
            <div style={{
                background: '#ff5252', color: '#fff', padding: '8px', 
                fontSize: '11px', textAlign: 'center', borderRadius: '5px', margin: '10px'
            }}>
                <span className="material-icons-round" style={{fontSize: '14px', verticalAlign: 'middle', marginRight: '5px'}}>gpp_maybe</span>
                VPN/Proxy အသုံးပြုထားသည်ကို တွေ့ရှိရပါသည်။
            </div>
          )}

          <div className="header">
            <h1 className="user-welcome">
                Hello, <br /> Welcome {userData?.name || 'User'}!
            </h1>
            <div onClick={() => setCurrentScreen('profile')} style={{ cursor: 'pointer' }}>
                <span className="material-icons-round" style={{fontSize: '45px', color: '#D4AF37'}}>account_circle</span>
            </div>
          </div>

          <div className="premium-gold-card">
            <p className="member-status-tag" style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>
              {userData?.memberType === 'Premium' 
             ? `Premium (${userData.premium || 0} Days Remaining)` 
             : 'Free Member'}
            </p>
            <h2 className="main-balance">{userData?.points?.toLocaleString() || 0}</h2>
            <p className="balance-label">Available Balance</p>

            {isAdmin && (
                <button onClick={() => setCurrentScreen('admin')} className="admin-badge-btn">
                   <span className="material-icons-round" style={{fontSize: '16px'}}>admin_panel_settings</span> Admin
                </button>
            )}
          </div>

          <div className="action-button-grid">
            <button className="action-btn" onClick={() => setCurrentScreen('promo')}>
               <span className="material-icons-round">local_offer</span> 
               <span>Promo/Ref</span>
            </button>

            <button 
                className="action-btn" 
                onClick={handleWatchAds}
                // 🔴 Admin က Block လုပ်ထားပြီး VPN မိနေရင် ခလုတ်ပိတ်ထားမယ်
                disabled={adCounting || adCooldown || isAdLoading || (vpnSettings.enabled && isVpnActive && vpnSettings.action === 'block')}
                style={{ 
                    background: (adCounting || adCooldown || isAdLoading || (vpnSettings.enabled && isVpnActive && vpnSettings.action === 'block')) ? '#e0e0e0' : '#FFF9C4',
                    border: (adCounting || isAdLoading) ? '2px solid #FBC02D' : 'none',
                    opacity: (vpnSettings.enabled && isVpnActive && vpnSettings.action === 'block') ? 0.6 : 1
                }}
            >
                <span className="material-icons-round" style={{color: (adCounting || adCooldown || isAdLoading) ? '#757575' : '#FBC02D'}}>
                  {isAdLoading ? 'sync' : (adCounting ? 'hourglass_top' : (adCooldown ? 'update' : (isVpnActive && vpnSettings.enabled && vpnSettings.action === 'block' ? 'vignette' : 'ads_click')))}
                </span> 
                <span style={{color: '#2C3E50', fontSize: '11px', fontWeight: 'bold'}}>
                  {isAdLoading ? 'ဖွင့်နေသည်...' : (adCounting ? `ကြည့်ပေးပါ (${timeLeft}s)` : (adCooldown ? `စောင့်ပါ (${timeLeft}s)` : (isVpnActive && vpnSettings.enabled && vpnSettings.action === 'block' ? 'VPN ပိတ်ပါ' : 'Watch Ads')))}
                </span>
            </button>

            <button className="action-btn" onClick={() => setCurrentScreen('tasks')}>
               <span className="material-icons-round">bolt</span> 
               <span>Earn</span>
            </button>
          </div>

          <div style={{textAlign: 'center', marginTop: '10px', fontSize: '12px', color: '#888'}}>
              ယနေ့ Ads ကြည့်ပြီးစီးမှု: {userData?.adsWatchedToday || 0} ကြိမ်
          </div>

          <div className="overview-section">
            <h3 className="overview-title" style={{marginBottom: '15px', fontWeight: '700'}}>Earned Overview</h3>
            <div className="overview-card">
                <div className="overview-item" onClick={() => setCurrentScreen('watch')}>
                    <div className="item-left">
                        <span className="material-icons-round" style={{color: '#D4AF37'}}>play_circle</span>
                        <span className="item-label">Watching</span>
                    </div>
                    <div className="item-right">
                        <span className="item-value">{userData?.watchPoints?.toLocaleString() || 0}</span>
                        <span className="material-icons-round arrow">chevron_right</span>
                    </div>
                </div>
                
                <div className="overview-item" onClick={() => setCurrentScreen('promo')}>
                    <div className="item-left">
                        <span className="material-icons-round" style={{color: '#4A90E2'}}>group</span>
                        <span className="item-label">Referrals</span>
                    </div>
                    <div className="item-right">
                        <span className="item-value">{userData?.refPoints?.toLocaleString() || 0}</span>
                        <span className="material-icons-round arrow">chevron_right</span>
                    </div>
                </div>

                <div className="overview-item" onClick={() => setCurrentScreen('tasks')}>
                    <div className="item-left">
                        <span className="material-icons-round" style={{color: '#00C853'}}>assignment</span>
                        <span className="item-label">Earn (Tasks)</span>
                    </div>
                    <div className="item-right">
                        <span className="item-value">{userData?.taskPoints?.toLocaleString() || 0}</span>
                        <span className="material-icons-round arrow">chevron_right</span>
                    </div>
                </div>
            </div>
          </div>

          <nav className="bottom-nav">
            <div className={`nav-item ${currentScreen === 'wallet' ? 'active' : ''}`} onClick={() => setCurrentScreen('wallet')}>
              <span className="material-icons-round">account_balance_wallet</span>
              <span>Wallet</span>
            </div>
            <div className={`nav-item ${currentScreen === 'watch' ? 'active' : ''}`} onClick={() => setCurrentScreen('watch')}>
              <span className="material-icons-round">play_circle</span>
              <span>Watch</span>
            </div>
            <div className={`nav-item ${currentScreen === 'dashboard' ? 'active' : ''}`} onClick={() => setCurrentScreen('dashboard')}>
              <span className="material-icons-round">home</span>
              <span>Home</span>
            </div>
            <div className={`nav-item ${currentScreen === 'shop' ? 'active' : ''}`} onClick={() => setCurrentScreen('shop')}>
              <span className="material-icons-round">shopping_bag</span>
              <span>Shop</span>
            </div>
            <div className={`nav-item ${currentScreen === 'profile' ? 'active' : ''}`} onClick={() => setCurrentScreen('profile')}>
              <span className="material-icons-round">person</span>
              <span>Profile</span>
            </div>
          </nav>
        </div>
      )}

      {currentScreen === 'admin' && <AdminPanel onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'profile' && <Profile userData={userData} onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'watch' && <Watch onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'wallet' && <Wallet onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'tasks' && <Tasks onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'shop' && <Shop onBack={() => setCurrentScreen('dashboard')} />}
      {currentScreen === 'promo' && <Promo onBack={() => setCurrentScreen('dashboard')} />}
    </div>
  );
}

export default App;